import BackToTop from './back-to-top';
import Suggest from './suggest';
import MobileQRCode from './mobile-qr-code';

export default {
  BackToTop,
  Suggest,
  MobileQRCode,
};
